<template>
  <div class="analytics-page">

    <!-- ===== PAGE HEADER ===== -->
    <div class="page-header">

      <div>
        <h1>Analytics & Reports</h1>
        <p>Monitor reputation trends, customer feedback, and campaign performance.</p>
      </div>

      <div class="header-actions">

        <button class="filter-btn">
          Last 30 Days
          <span class="material-symbols-outlined">expand_more</span>
        </button>

        <button class="filter-btn">
          All Platforms
          <span class="material-symbols-outlined">expand_more</span>
        </button>

        <button class="ghost-btn">
          <span class="material-symbols-outlined">download</span>
          Export
        </button>

      </div>

    </div>

    <!-- ===== METRICS STRIP ===== -->
    <div class="metrics-grid">

      <div class="metric-card">
        <span>Average Rating</span>
        <strong>4.8</strong>
        <small class="positive">↑ +0.3</small>
      </div>

      <div class="metric-card">
        <span>Total Reviews</span>
        <strong>1,284</strong>
        <small class="positive">↑ +12%</small>
      </div>

      <div class="metric-card">
        <span>Review Velocity</span>
        <strong>6.2 / day</strong>
        <small class="neutral">Stable</small>
      </div>

      <div class="metric-card">
        <span>Total Referrals</span>
        <strong>842</strong>
        <small class="positive">↑ +8%</small>
      </div>

      <div class="metric-card">
        <span>Conversion Rate</span>
        <strong>18.6%</strong>
        <small class="positive">↑ Improving</small>
      </div>

      <div class="metric-card">
        <span>QR Scans</span>
        <strong>284</strong>
        <small class="positive">↑ +12 today</small>
      </div>

    </div>

    <!-- ===== CHARTS GRID ===== -->
    <div class="charts-grid">

      <!-- Review Growth -->
      <div class="chart-card large">
        <div class="card-header">
          <h3>Review Growth</h3>
        </div>
        <div id="growthChart"></div>
      </div>

      <!-- Rating Trend -->
      <div class="chart-card">
        <div class="card-header">
          <h3>Rating Trend</h3>
        </div>
        <div id="ratingChart"></div>
      </div>

      <!-- Platform Breakdown -->
      <div class="chart-card">
        <div class="card-header">
          <h3>Platform Breakdown</h3>
        </div>
        <div id="platformChart"></div>
      </div>

      <!-- Sentiment Distribution -->
      <div class="chart-card">
        <div class="card-header">
          <h3>Customer Sentiment</h3>
        </div>
        <div id="sentimentChart"></div>
      </div>

      <!-- Campaign Performance -->
      <div class="chart-card">
        <div class="card-header">
          <h3>Campaign Performance</h3>
        </div>
        <div id="campaignChart"></div>
      </div>

      <!-- QR Scan Trend -->
      <div class="chart-card">
        <div class="card-header">
          <h3>QR Scan Trend</h3>
        </div>
        <div id="qrChart"></div>
      </div>

    </div>

  </div>
</template>

<script>
import ApexCharts from "apexcharts";

export default {
  name: 'AnalyticsReportsScreen',

  mounted() {
    this.renderCharts();
  },

  methods: {
    renderCharts() {

      /* ===== REVIEW GROWTH ===== */

      new ApexCharts(document.querySelector("#growthChart"), {
        chart: { type: "area", height: 260, toolbar: { show: false }},
        series: [{
          name: "Reviews",
          data: [32, 48, 61, 79, 102, 128]
        }],
        stroke: { curve: "smooth", width: 3 },
        fill: {
          type: "gradient",
          gradient: { opacityFrom: 0.25, opacityTo: 0 }
        },
        colors: ["#197fe6"],
        xaxis: {
          categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Now"]
        },
        dataLabels: { enabled: false },
        grid: { borderColor: "#f1f5f9" }
      }).render();


      /* ===== RATING TREND ===== */

      new ApexCharts(document.querySelector("#ratingChart"), {
        chart: { type: "line", height: 260, toolbar: { show: false }},
        series: [{
          name: "Rating",
          data: [4.2, 4.4, 4.5, 4.6, 4.7, 4.8]
        }],
        stroke: { curve: "smooth", width: 3 },
        colors: ["#22c55e"],
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Now"]
        },
        dataLabels: { enabled: false },
        grid: { borderColor: "#f1f5f9" }
      }).render();


      /* ===== PLATFORM BREAKDOWN ===== */

      new ApexCharts(document.querySelector("#platformChart"), {
        chart: { type: "donut", height: 260 },
        series: [820, 310, 154],
        labels: ["Google", "Facebook", "Others"],
        colors: ["#197fe6", "#38bdf8", "#cbd5f5"],
        legend: { position: "bottom" },
        dataLabels: { enabled: false }
      }).render();


      /* ===== SENTIMENT ===== */

      new ApexCharts(document.querySelector("#sentimentChart"), {
        chart: { type: "bar", height: 260, toolbar: { show: false }},
        series: [{
          name: "Customers",
          data: [72, 20, 8]
        }],
        xaxis: { categories: ["Happy", "Neutral", "Unhappy"] },
        colors: ["#22c55e"],
        plotOptions: {
          bar: { borderRadius: 6, columnWidth: "45%" }
        },
        dataLabels: { enabled: false }
      }).render();


      /* ===== CAMPAIGN PERFORMANCE ===== */

      new ApexCharts(document.querySelector("#campaignChart"), {
        chart: { type: "radialBar", height: 260 },
        series: [98, 45, 12],
        labels: ["Delivery", "Open Rate", "Conversion"],
        colors: ["#22c55e", "#197fe6", "#38bdf8"],
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: { fontSize: "12px" },
              value: { fontSize: "16px" }
            }
          }
        }
      }).render();


      /* ===== QR SCAN TREND ===== */

      new ApexCharts(document.querySelector("#qrChart"), {
        chart: { type: "line", height: 260, toolbar: { show: false }},
        series: [{
          name: "Scans",
          data: [12, 18, 26, 34, 45]
        }],
        stroke: { curve: "smooth", width: 3 },
        colors: ["#197fe6"],
        xaxis: {
          categories: ["Mon", "Tue", "Wed", "Thu", "Today"]
        },
        dataLabels: { enabled: false }
      }).render();
    }
  }
}
</script>

<style scoped>

.analytics-page {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #f6f7f8;
  min-height: 100vh;
}

/* HEADER */

.page-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 800;
}

.page-header p {
  font-size: 14px;
  color: #64748b;
}

/* ACTIONS */

.header-actions {
  display: flex;
  gap: 8px;
}

/* METRICS */

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(180px,1fr));
  gap: 12px;
}

.metric-card {
  background: white;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.metric-card span {
  font-size: 12px;
  color: #64748b;
}

.metric-card strong {
  font-size: 22px;
  display: block;
  margin-top: 6px;
}

/* CHART GRID */

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(320px,1fr));
  gap: 14px;
}

.chart-card {
  background: white;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid #e2e8f0;
}

.chart-card.large {
  grid-column: span 2;
}

/* HEADER */

.card-header h3 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

/* BUTTONS */

.filter-btn,
.ghost-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.positive { color: #16a34a; }
.neutral { color: #94a3b8; }

/* MOBILE */

@media(max-width:768px) {

  .analytics-page {
    padding: 16px;
  }

  .chart-card.large {
    grid-column: span 1;
  }

}

</style>
